import React from "react";

import { getTrainingDocType } from "../../../../redux/directoryMaintenance/trainingDocTypesReducer/actionsTrainingDocTypes";

import TrainingDocTypesModal from "./trainingDocTypesModal/trainingDocTypesModal";
import GeneralSectionComponent from "../generalSectionComponent";

import { TRAINING_DOC_TYPES_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

function TrainingDocTypes() {
  return (
    <GeneralSectionComponent
      title={"Виды документов об обучении"}
      headerColumns={TRAINING_DOC_TYPES_COLUMNS}
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allTrainingDocTypes
      }
      getAction={getTrainingDocType}
      ModalComponent={TrainingDocTypesModal}
    />
  );
}

export default TrainingDocTypes;
